import { useCallback } from '@wordpress/element';
const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls, InnerBlocks } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;
const { useSelect } = wp.data;

import {
  getCurrentPostAcfFields,
  parseHubSpotShortcode,
} from '../utils/methods';
import $ from 'jquery';

registerBlockType('pg/course-details', {
  title: __('PG Course Details'),
  icon: 'welcome-learn-more',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
    courseFormTitle: {
      type: 'string',
      default: 'Sign up for free course',
    },
    courseFormShortcode: {
      type: 'string',
      default: '',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { sectionClass, courseFormTitle, courseFormShortcode } = attributes;

    const [loaded, setLoaded] = useState(false);
    const acfFields = acf.getFields();

    const postMeta =
      useSelect(
        (select) => select('core/editor').getEditedPostAttribute('meta'),
        []
      ) || [];

    useEffect(() => {
      if (postMeta) {
        setAttributes({
          courseFormShortcode:
            postMeta.course_form_shortcode ||
            postMeta.article_form_shortcode ||
            null,
        });
      }
    }, [postMeta]);

    const refreshMeta = useCallback(
      (event, field) => {
        event.preventDefault();
        event.stopPropagation();

        if (
          field.data.name === 'course_form_shortcode' ||
          field.data.name === 'article_form_shortcode'
        ) {
          postMeta[field.data.name] = event.target.value;
          setAttributes({ courseFormShortcode: event.target.value });
        }
      },
      [postMeta, setAttributes]
    );

    useEffect(() => {
      if (!acfFields) {
        return;
      }

      acfFields.forEach((field) => {
        $(`[name=acf\\[${field.data.key}\\]]`).on('change', (event) =>
          refreshMeta(event, field)
        );
      });

      acfFields.forEach((field) =>
        $(`[name=acf\\[${field.data.key}\\]]`).trigger('change')
      );

      return () => {
        acfFields.forEach((field) =>
          $(`[name=acf\\[${field.data.key}\\]]`).off('change')
        );
      };
    }, [acfFields]);

    const loadHubSpotScript = () => {
      if (window.hbspt) {
        setLoaded(true);
        return;
      }

      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/v2.js';
      script.onload = () => setLoaded(true);
      document.body.appendChild(script);
    };

    useEffect(() => {
      loadHubSpotScript();
    }, []);

    useEffect(() => {
      if (loaded && courseFormShortcode) {
        const { portalId, formId } = parseHubSpotShortcode(courseFormShortcode);
        if (portalId && formId) {
          window.hbspt.forms.create({
            portalId,
            formId,
            target: '.form-container-inner',
          });
        }
      }
    }, [loaded, courseFormShortcode]);

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Section Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div className="course-details-section-wrapper">
            <div className="content-container">
              <div className="content-wrapper">
                <InnerBlocks
                  allowedBlocks={[
                    'core/paragraph',
                    'core/image',
                    'core/heading',
                    'core/list',
                    'core/embed',
                    'core/table',
                    'core/freeform',
                    'core/quote',
                    'pg/faq-inner-section',
                    'pg/checklist',
                    'pg/button',
                    'pg/banner',
                    'pg/list',
                  ]}
                  template={[
                    [
                      'core/paragraph',
                      {
                        placeholder:
                          'Start writing or type / to choose a block',
                      },
                    ],
                  ]}
                />
              </div>

              <div className="form-wrapper get-demo-section-wrapper">
                <div className="form-container">
                  <RichText
                    tagName="h4"
                    value={courseFormTitle}
                    onChange={(value) =>
                      setAttributes({ courseFormTitle: value })
                    }
                    placeholder={__('Form Title...')}
                  />
                  <div className="form-container-inner">
                    {courseFormShortcode && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: courseFormShortcode,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: () => {
    // The save function will be handled by PHP.
    return <InnerBlocks.Content />;
  },
});
